module.exports = __webpack_public_path__ + "media/images/application/subscribe/background-subscribe-no-bg-d6bc7d94d421cde8f083cef9eb8efd8e.svg";